module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cross-domain-callback"
  }, [_c('div', {
    staticClass: "container text-left"
  }, [_c('h4', [_vm._v("Local do iFrame: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.local))]), _vm._v(" "), _c('h4', [_vm._v("Origem dos dados: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.origin))]), _vm._v(" "), _c('h4', [_vm._v("Dados recebidos: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.data))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4869d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CrossDomainCallback.vue
// module id = 171
// module chunks = 0